import React from "react";
import {
    Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody,
} from "@chakra-ui/react";

/**
 * Right-side drawer that hosts a full (existing) management component on a
 * deliberate dark "focus" surface. Children are mounted lazily (only while
 * open) so heavy components don't fetch until the admin opens them.
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether the drawer is open
 * @param {Function} props.onClose - Close handler
 * @param {string} props.title - Drawer header title
 * @param {React.ReactNode} props.children - Management component to host
 * @returns {React.ReactElement}
 */
function ManageDrawer({ isOpen, onClose, title, children }) {
    return (
        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="lg">
            <DrawerOverlay />
            <DrawerContent background="rgba(20, 22, 28, 0.98)" backdropFilter="blur(20px)">
                <DrawerCloseButton color="rgba(255,255,255,0.85)" />
                <DrawerHeader color="rgba(255,255,255,0.95)" fontSize="0.95rem" fontWeight={600}
                    borderBottom="1px solid rgba(255,255,255,0.1)">
                    {title}
                </DrawerHeader>
                <DrawerBody p="16px">{isOpen ? children : null}</DrawerBody>
            </DrawerContent>
        </Drawer>
    );
}

export default ManageDrawer;
